<template>
    <div :id="idVal" :class="classVal">
        <div class="spinner-border ic-spinner ic-spinner-green" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loader',
        props: {
            idVal: String,
            classVal: String
        }
    }
</script>

<style>
    .ic-spinner {
        width: 2.8125rem;
        height: 2.8125rem;
        border-width: 2px;
    }
    .ic-spinner-green {
        border: 1px solid #2eb085;
        border-right-color: transparent !important;
    }
    @keyframes spinner-border {
        to { transform: rotate(360deg); }
    }
    .spinner-border {
        display: inline-block;
        vertical-align: text-bottom;
        border-right-color: transparent;
        border-radius: 50%;
        animation: spinner-border .75s linear infinite;
    }
    @keyframes spinner-grow {
        0% {
            transform: scale(0);
        }
        50% {
            opacity: 1;
            transform: none;
        }
    }
    .spinner-grow {
        display: inline-block;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: 0;
        animation: spinner-grow .75s linear infinite;
    }
    .sr-only{
        position:absolute;
        width:1px;
        height:1px;
        padding:0;
        overflow:hidden;
        clip:rect(0,0,0,0);
        white-space:nowrap;border:0
    }
    .sr-only-focusable:active,.sr-only-focusable:focus{
        position:static;
        width:auto;
        height:auto;
        overflow:visible;
        clip:auto;
        white-space:normal
    }
</style>